<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2>Profile</h2>
			</b-col>
		</div>
		<div>
			<b-card v-if="loadingData">
				<b-col cols="12" sm="12" md="12" lg="12">
					<p class="text-center">
						<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
					</p>
				</b-col>
			</b-card>
			<div v-else>
				<b-card v-if="found">
						<b-row>
							<b-col md="8">
								<b-form-group :label-cols="4" id="L4" label="User Role:" label-for="RoleID" horizontal>
									<b-form-input v-show="!edit" class="plaintext-input" plaintext id="RoleID" v-model="model.role" type="text"></b-form-input>
								</b-form-group>
								<b-form-group label="Username:" label-for="Username" :label-cols="4" horizontal>
									<b-form-input v-show="!edit" class="plaintext-input" plaintext v-model="model.username" type="text" />
								</b-form-group>
								<b-form-group label="First Name:" label-for="FirstName" :label-cols="4" horizontal>
									<b-form-input v-show="!edit" class="plaintext-input" plaintext v-model="model.first_name" type="text" />
								</b-form-group>
								<b-form-group label="Last Name:" label-for="LastName" :label-cols="4" horizontal>
									<b-form-input v-show="!edit" class="plaintext-input" plaintext v-model="model.last_name" type="text" />
								</b-form-group>
								<b-form-group label="Email:" label-for="Email" :label-cols="4" horizontal>
									<b-form-input v-show="!edit" class="plaintext-input" plaintext v-model="model.email" type="text" />
								</b-form-group>
								<b-form-group v-show="!nopassword" label="New Password" label-for="nPassword" :label-cols="4" horizontal>
									<b-form-input id="nPassword" autocomplete="new-password" type="password" v-model="new_password" class="form-control" />
								</b-form-group>
								<b-form-group v-show="!nopassword" label="Confirm new Password" label-for="cnPassword" :label-cols="4" horizontal>
									<b-form-input id="cnPassword" autocomplete="new-password" type="password" v-model="confirm_new_password" class="form-control" />
								</b-form-group>
								<div slot="footer">
									<b-button v-show="nopassword" @click="resetpass" size="sm" variant="primary"><i class="fa fa-edit"></i> Reset Password</b-button>
									<b-button v-show="!nopassword" @click="updatepass" size="sm" variant="primary"><i class="fa fa-edit"></i> Update Password</b-button>
									<b-button v-show="!nopassword" @click="cancelpass" size="sm" variant="secondary"><i class="fa fa-edit"></i> Cancel</b-button>		
								</div>
							</b-col>
						</b-row>
				</b-card>
				<b-row v-else>
					<b-col cols="12" sm="12" md="12" lg="12">
						<br>
						<p class="text-center text-danger">
							<i class="icon fa-lg icon-puzzle"></i><br>{{notFoundMessage}}
						</p>
					</b-col>
				</b-row>
			</div>
		</div>
	</div>
</template>

<script>
	// ********** imports ************ //

	import profile_service from './profile_service'

	export default {
		name: 'profile',
		props: {
			id: {
				type: String,
				default: 0
			}
		},
		created: function() {
			this.getProfileData()
		},
		data() {
			return {
				edit			: false,
				loadingData		: true,
				found			: false,
				notFoundMessage	: 'Not found',
				model			: {
            						first_name 	: '',
            						last_name 	: '',
									usename 	: '',
            						email 		: '',
            						role 		: ''
								 },
				nopassword 			: true,
				new_password		: '',
				confirm_new_password: '',
			}
		},
		methods: {
			getProfileData() {
				profile_service.getBy(this.id)
					.then(data => {
						if (data[0] === 'success') {
							this.model = data[1]
							this.found = true
							this.loadingData = false
						} else {
							this.loadingData = false
							this.$swal(data[0], data[1], data[0])
							// this.getAll()
							return
						}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
			resetpass() {
				this.nopassword=false
			},
			cancelpass() {
				this.nopassword				= true
				this.new_password			= ''
				this.confirm_new_password	= ''
			},
			updatepass() {
				
				if (!this.okToUpdate()) {
					return
				}
				let dataUser = {
				    new_password		: this.new_password,
     				new_new_password	: this.confirm_new_password
				}
				profile_service.reset_password(dataUser)
					.then(data => {
						this.$swal(data[0], data[1], data[0])
						if (data[0] === 'success') {
							this.nopassword=true
						} else {
							this.nopassword=true
							return
						}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					})
				
			},
			okToUpdate() {

				if(String(this.new_password).trim().length > 0 && String(this.confirm_new_password).trim().length > 0 ) {
 					if(String(this.confirm_new_password).trim() !== String(this.new_password).trim()) {
						this.$swal('Alert!', 'New Password does not match the confirm password', 'warning')
						return false
					}
				} else {
					if (String(this.new_password).trim().length == 0 ) {
						this.$swal('Alert!', 'New Password can not be empty', 'warning')
						return false
					} else if (String(this.confirm_new_password).trim().length == 0 ) {
						this.$swal('Alert!', 'Confirm new Password can not be empty', 'warning')
						return false
					}
				}
				return true
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/profile/profile.vue